import React from "react";

function FAQ() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0379 10.6793L20.62 9.01654C20.3574 8.70083 20.1369 8.1115 20.1369 7.69055V5.90153C20.1369 4.78602 19.2232 3.87046 18.1099 3.87046H16.3244C15.9043 3.87046 15.3057 3.64946 14.9906 3.38637L13.3312 1.96567C12.6065 1.34478 11.4197 1.34478 10.695 1.96567L9.01462 3.38637C8.69954 3.64946 8.11139 3.87046 7.69129 3.87046H5.87434C4.76106 3.87046 3.84733 4.78602 3.84733 5.90153V7.69055C3.84733 8.10098 3.63728 8.6903 3.37472 9.00601L1.95686 10.6793C1.34771 11.4159 1.34771 12.5946 1.95686 13.3102L3.37472 14.9835C3.63728 15.2886 3.84733 15.8885 3.84733 16.2989V18.0985C3.84733 19.214 4.76106 20.1295 5.87434 20.1295H7.70179C8.11139 20.1295 8.71004 20.3505 9.02512 20.6136L10.6845 22.0343C11.4092 22.6552 12.596 22.6552 13.3207 22.0343L14.9801 20.6136C15.2952 20.3505 15.8833 20.1295 16.3034 20.1295H18.0889C19.2021 20.1295 20.1159 19.214 20.1159 18.0985V16.3094C20.1159 15.8885 20.3364 15.2992 20.599 14.9835L22.0168 13.3207C22.6575 12.6051 22.6575 11.4159 22.0379 10.6793ZM11.2097 7.9326C11.2097 7.50113 11.5668 7.14332 11.9974 7.14332C12.428 7.14332 12.7851 7.50113 12.7851 7.9326V13.0155C12.7851 13.447 12.428 13.8048 11.9974 13.8048C11.5668 13.8048 11.2097 13.447 11.2097 13.0155V7.9326ZM11.9974 17.1303C11.4197 17.1303 10.9471 16.6567 10.9471 16.0779C10.9471 15.4991 11.4092 15.0256 11.9974 15.0256C12.575 15.0256 13.0476 15.4991 13.0476 16.0779C13.0476 16.6567 12.5855 17.1303 11.9974 17.1303Z"
        fill="#C55750"
      />
    </svg>
  );
}

export default FAQ;
